import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import booking from "../features/booking";
import common from "../features/common";
import shop from "../features/shop";

export const store = configureStore({
  reducer: {
    common,
    shop,
    booking,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
